import { render, staticRenderFns } from "./morder.vue?vue&type=template&id=37182192&scoped=true"
import script from "./morder.vue?vue&type=script&lang=js"
export * from "./morder.vue?vue&type=script&lang=js"
import style0 from "./morder.vue?vue&type=style&index=0&id=37182192&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37182192",
  null
  
)

export default component.exports